export default "__VITE_ASSET__3ibo6FPw__"